'use client';

import React from 'react';
import { FileText, CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
import type { ProcessingStats } from '../lib/types';
import Icon from '@/components/ui/AppIcon';


interface StatCardsProps {
  stats: ProcessingStats;
  isProcessing: boolean;
}

const cards = [
  {
    key: 'total' as const,
    label: 'PDFs encontrados',
    icon: FileText,
    colorClass: 'text-primary',
    bgClass: 'bg-info-bg border-info-border',
    valueClass: 'text-foreground',
  },
  {
    key: 'renamed' as const,
    label: 'Renomeados com sucesso',
    icon: CheckCircle2,
    colorClass: 'text-success',
    bgClass: 'bg-success-bg border-success-border',
    valueClass: 'text-success',
  },
  {
    key: 'warnings' as const,
    label: 'Avisos (nome não encontrado)',
    icon: AlertTriangle,
    colorClass: 'text-warning',
    bgClass: 'bg-warning-bg border-warning-border',
    valueClass: 'text-warning',
  },
  {
    key: 'errors' as const,
    label: 'Erros de processamento',
    icon: XCircle,
    colorClass: 'text-error',
    bgClass: 'bg-error-bg border-error-border',
    valueClass: 'text-error',
  },
];

export default function StatCards({ stats, isProcessing }: StatCardsProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        const value = stats[card.key];

        return (
          <div
            key={`stat-${card.key}`}
            className={`rounded-xl border px-5 py-4 ${card.bgClass} transition-all duration-300`}
          >
            <div className="flex items-start justify-between mb-3">
              <Icon size={20} className={card.colorClass} />
              {isProcessing && card.key === 'total' && (
                <span className="text-xs text-muted-foreground animate-pulse">a contar...</span>
              )}
            </div>
            <div className={`text-3xl font-bold text-tabular ${card.valueClass} leading-none`}>
              {value}
            </div>
            <p className="text-xs text-muted-foreground mt-1.5 leading-snug font-medium">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}